module.exports = __webpack_public_path__ + "static/media/11.263ac696.JPG";